import React from "react";
import { Typography } from "@mui/material";

import GlobalTooltip from "../../../utility/tooltip/globalTooltip";
import useIsTruncated from "../../../../hooks/useIsTruncated";
import Required from "../../../utility/required";

type SampleVariableKeyLabelProps = {
    variableKey: string;
    className?: string;
    required?: boolean;
};

const SampleVariableKeyLabel = ({ variableKey, className, required = false }: SampleVariableKeyLabelProps) => {
    
    const { ref: labelRef, isTruncated } = useIsTruncated(variableKey);

    return (
        <GlobalTooltip
            placement="top"
            arrow
            title={isTruncated ? variableKey : ""}
            disableHoverListener={!isTruncated}
        >
            <Typography
                component="span"
                ref={labelRef}
                className={className}
            >
                {variableKey}
                {required && <Required />}
            </Typography>
        </GlobalTooltip>
    );
};

export default SampleVariableKeyLabel;
